import statusEnum from '../status.enum';
import i18n from 'i18n-js';

const useListStatusTranslations = () => {
  const statusTypeLabel = (type) => {
    switch (type) {
      case statusEnum.PASSED:
        return i18n.t('qualifications.passed_status');
      case statusEnum.FAILED:
        return i18n.t('qualifications.failed_status');
      case statusEnum.NOT_PERFORMED:
        return i18n.t('qualifications.not_performed_status');
      case statusEnum.NOT_APPLICABLE:
        return i18n.t('qualifications.not_applicable_satus');
      case statusEnum.DECLINED:
        return i18n.t('qualifications.declined_status');
      case statusEnum.APPROVED:
        return i18n.t('qualifications.approved_status');
      default:
        return i18n.t(`qualifications.${type}`);
    }
  };

  return {
    statusTypeLabel: statusTypeLabel,
  };
};

export default useListStatusTranslations;
